import React, { Component } from 'react'
import "./index.scss"
import QueueAnim from 'rc-queue-anim';
import { TweenOneGroup } from 'rc-tween-one';
import { useNavigate } from 'react-router-dom';
import { withParams } from '../../../utils/util'
import { connect } from 'react-redux';
import {
	Button,
	Row,
	Col,
	Card,
	Avatar,
	Carousel,
	Skeleton,
} from 'antd';
import {
	DoubleRightOutlined,
	CheckCircleOutlined,
	PhoneOutlined
} from '@ant-design/icons';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { home } from '../../../service'

const demand_icon = require("./image/demand.png")
	, services_icon = require("./image/services.png")
	, company_icon = require("./image/company.png")

class HomeView extends Component {
	state = {
		current: 'mail',
		dataSeivice: { children: [] },				// 服务动态
		dataDemand: { children: [] },				// 需求动态
		dataCompany: { children: [] },				// 组织名录
		carouselImgs: [],							// 获取轮播图
	}

	componentDidMount() {
		this.fetch()
	}

	fetch = async () => {
		try {

			const res1 = await home.getCarouselList()				// 轮播图
			this.setState({ carouselImgs: res1.data })

			const res2 = await home.apiList.getSerList()				// 服务动态
			this.setState({
				dataSeivice: {
					className: 'content0-block-wrapper',
					children: res2.data
				}
			})
			const res3 = await home.apiList.getDemList()				// 需求动态

			// const [res1, res2, res3] = await Promise.all([fn1, fn2, fn3])

			this.setState({
				dataDemand: {
					className: 'content0-block-wrapper',
					children: res3.data
				},
			})

			// const res4 = await home.getCompanyList()

			// this.setState({
			// 	dataCompany: {
			// 		className: 'content0-block-wrapper',
			// 		children: res4.data
			// 	}
			// })
		} catch (error) {
			console.log(error);
		}
	}

	onMoreClick = (path) => {
		this.props.navigate(path)
	}

	navigateDetail = (id, mode) => {
		if (mode === 'service') {
			this.props.navigate(`/serviceshall/details/${id}`)
		} else if (mode === 'demand') {
			this.props.navigate(`/demandhall/details/${id}`)
		}
	}

	render() {
		const { dataSeivice, dataDemand, dataCompany, carouselImgs } = this.state
			, { onMoreClick, navigateDetail } = this
			, { serverUrl, basicId } = this.props
		return (
			<div className='homg-page container-display-center'>

				{
					carouselImgs && carouselImgs.length ? (
						<Carousel
							autoplay
							effect="fade"
							className='carousel-list'
						>
							{
								carouselImgs.map((item) => (
									<img
										className='separate-carousel-img-custom'
										key={item.id}
										src={serverUrl + item.images}
										alt=""
									/>
								))
							}
						</Carousel>
					) : (
						<Skeleton.Image active style={{ width: '1200px', height: '500px' }} />
					)
				}

				<div className='trends'>
					<OverPack
						className='overPack-custom'
						playScale={0.1}
					>

						<div className='trends-header'>
							<div className='trends-header-title'>
								<img src={services_icon} alt="" />
								服务动态
							</div>
							<div className='trends-header-more'>
								<Button
									type='text'
									onClick={() => onMoreClick('/serviceshall')}
								>
									更多
									<DoubleRightOutlined />
								</Button>
							</div>
							<div className='trends-header-border'></div>
						</div>
						<QueueAnim
							type="bottom"
							key="block"
							leaveReverse
							component={Row}
							componentProps={dataSeivice}
							className='queueAnim-cuntom'
						>
							{dataSeivice.children.map((item, i) => {
								return (
									<Col key={i.toString()} span={6} className='queueAnim-col'>
										<Card
											hoverable
											className='queueAnim-card'
											cover={
												<img
													src={this.props.serverUrl + item.imageUrl}
													className='queueAnim-card-img'
													alt=""
												/>}
											actions={[
												<span>{'法人代表：' + item.frdb}</span>,
											]}
											onClick={() => navigateDetail(item.id, 'service')}
										>
											<Card.Meta
												title={`${item.name}`}
												description={item.address}
											/>
										</Card>
									</Col>
								);
							})}
						</QueueAnim>
					</OverPack>
				</div>

				<div className='trends'>
					<OverPack
						className='overPack-custom'
						playScale={0.15}
					>
						<div className='trends-header'>
							<div className='trends-header-title'>
								<img src={demand_icon} alt="" />
								需求动态
							</div>
							<div className='trends-header-more'>
								<Button
									type='text'
									onClick={() => onMoreClick('/demandhall')}
								>
									更多
									<DoubleRightOutlined />
								</Button>
							</div>
							<div className='trends-header-border'></div>
						</div>
						<QueueAnim
							type="bottom"
							key="block"
							leaveReverse
							component={Row}
							componentProps={dataDemand}
							className='queueAnim-cuntom'
						>
							{dataDemand.children.map((item, i) => {
								return (
									<Col key={i.toString()} span={6} className='queueAnim-col'>
										<Card
											hoverable
											className='queueAnim-card'
											cover={
												<img
													src={this.props.serverUrl + item.imageUrl}
													className='queueAnim-card-img'
													alt=""
												/>}
											actions={[
												<span>{'法人代表：' + item.frdb}</span>,
											]}
											onClick={() => navigateDetail(item.id, 'demand')}
										>
											<Card.Meta
												title={`${item.name}`}
												description={item.address}
											/>
										</Card>
									</Col>
								);
							})}
						</QueueAnim>
					</OverPack>
				</div>

				{/* <div className='trends'>
					<OverPack
						className='overPack-custom'
						playScale={0.05}
					>
						<div className='trends-header'>
							<div className='trends-header-title'>
								<img src={company_icon} alt="" />
								组织名录
							</div>
							<div className='trends-header-more'>
								<Button
									type='text'
									onClick={() => onMoreClick('/companyhall')}
								>
									更多
									<DoubleRightOutlined />
								</Button>
							</div>
							<div className='trends-header-border'></div>
						</div>
						<TweenOneGroup
							component={Row}
							key="ul"
							enter={{
								y: '+=30',
								opacity: 0,
								type: 'from',
								ease: 'easeInOutQuad',
							}}
							leave={{ y: '+=30', opacity: 0, ease: 'easeInOutQuad' }}
							{...dataCompany}
						>
							{
								dataCompany.children.map((item) => {
									return (
										<Col span={8} key={item.id}>
											<Card
												style={{
													width: 380,
													marginBottom: 16,
												}}
												actions={[
													<span style={{ color: '#2CB861' }}><CheckCircleOutlined /> 已认证</span>,
													<span><PhoneOutlined /> {
														basicId ? (<>{item.mobile}</>) : (<>{item.mobile.slice(0, 7) + '****'}</>)
													}</span>,
												]}
											>
												<Card.Meta
													avatar={<Avatar
														src={serverUrl + item.imageUrl}
														style={{ width: '100px', height: '100px' }}
													/>}
													title={item.companyName}
													description={item.address}
												/>
											</Card>
										</Col>
									);
								})
							}
						</TweenOneGroup>
					</OverPack>
				</div> */}

			</div>
		)
	}
}

const mapStateToProps = (state) => ({
	serverUrl: state.siteInfo.serverUrl,
	basicId: state.basic.id
})
const ConnectedHomeView = connect(mapStateToProps)(HomeView);

export default withParams(ConnectedHomeView, () => { }, () => { }, useNavigate)
